import React from "react";
import Login from "../components/Login";

function LoginRegister() {
    return (
      <>
        <Login />
      </>
    );
  };
  
export default LoginRegister;